import React from 'react';

const UserIcon = ({ ...props }) => (
  <svg
    fill="none"
    viewBox="0 0 16 20"
    {...props}
  >
    <path
      strokeLinejoin="round"
      d="M11.767 4.933a3.767 3.767 0 11-7.534 0 3.767 3.767 0 017.534 0zM15.335 17.43c.127.721-.477 1.403-1.335 1.403H2c-.858 0-1.462-.682-1.335-1.404.734-4.178 3.794-7.196 7.335-7.196s6.601 3.018 7.335 7.196z"
    />
  </svg>
);

export default UserIcon;
